import * as React from 'react';

import { Container, LegacyContainerStatus } from 'types/Watchlist';
import { statusMapping } from './utility';

import { CellProps } from '../types';
import { Cell } from '../Cell';

export const StateCell: React.FC<CellProps> = (params) => {
  const container: Container = params.row;

  const { status, pickupInfo } = container;

  const mapping = statusMapping(container, status);

  let content: React.ReactNode = null;
  switch (status) {
    case LegacyContainerStatus.Import:
    case LegacyContainerStatus.OnVessel: {
      const available = pickupInfo?.isAvailableForPickup && !pickupInfo?.yardLocation.closedArea;
      content = (
        <div className={`${available ? 'text-green-600' : 'text-red-900'} space-y-2`}>
          <h5>{available ? 'Available for pickup' : 'Not available for pickup'}</h5>
          {status === LegacyContainerStatus.Import && pickupInfo?.yardLocation.closedArea && (
            <h6 className="uppercase font-medium">Closed Area</h6>
          )}
        </div>
      );
      break;
    }
    default:
      break;
  }

  return (
    <Cell className="space-y-1 text-center flex items-center flex-col justify-items-start">
      <div className="flex space-x-1 items-center">
        <img src={mapping.image} alt={mapping.label} style={{ height: 16 }} />
        <h5 className="uppercase font-medium">{mapping.label}</h5>
      </div>
      {content}
    </Cell>
  );
};
StateCell.displayName = 'ContainerTable.StateCell';
